import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=598aff92&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=598aff92&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598aff92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('598aff92')) {
      api.createRecord('598aff92', component.options)
    } else {
      api.reload('598aff92', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=598aff92&scoped=true&", function () {
      api.rerender('598aff92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/DataTable.vue"
export default component.exports